class CreateAccountingSession {
  constructor() {
    this.id = undefined;
    this.timeStamp = undefined;
    this.sessionId = undefined;
    this.patientId = undefined;
    this.therapistId = undefined;
    this.accountingTherapistHourId = undefined;
    this.isPaidFor = undefined;
    this.isAdmitted = undefined;
    this.isAbsent = undefined;
    this.isException = undefined;
    this.originalPrice = undefined;
    this.finalPrice = undefined;
    this.discount = undefined;
    this.appointmentId = undefined;
    this.accountingEntryId = undefined;
    this.sessionName = undefined;
    this.noAppointmentOnly = undefined;
    this.appointmentDateFrom = undefined;
    this.appointmentDateTo = undefined;
    this.timeStampFrom = undefined;
    this.timeStampTo = undefined;
    this.phoneNumber = undefined;
    this.pagingParams = {
      pageNumber: undefined,
      pageSize: undefined,
    };
  }
}
export default CreateAccountingSession;
